"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.CompletionModal = exports.CompletionBody = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var NoOp = function NoOp() {};

var CompletionBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CompletionBody, _Component);

  function CompletionBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CompletionBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CompletionBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "course", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "rewards", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "passed", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "nextItem", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      showingNext: false
    };
    return _this;
  }

  babelHelpers.createClass(CompletionBody, [{
    key: "render",
    value: function render() {
      if (this.state.showingNext) {
        return _react.default.createElement("section", {
          className: "completion-page"
        }, _react.default.createElement("div", {
          className: "block stack catalog-group height-auto course-completion-next"
        }, this.nextItem.headline && _react.default.createElement("div", {
          className: "container"
        }, _react.default.createElement("h1", null, this.nextItem.headline), this.nextItem.subText && _react.default.createElement("p", null, this.nextItem.subText)), _react.default.createElement("div", null, _react.default.createElement("div", {
          className: "card-container card-grid card-centered"
        }, _react.default.createElement(require(this.nextItem.tile.child_type).default, this.nextItem.tile)))), false && _react.default.createElement("footer", null, _react.default.createElement("button", {
          className: "btn btn-primary",
          "data-dismiss": "modal",
          type: "button"
        }, "Close")));
      }

      return _react.default.createElement("section", {
        className: "completion-page"
      }, _react.default.createElement("header", {
        className: "completion-header productHeader",
        style: {
          backgroundImage: this.course.listImage_name ? "url(".concat(this.course.listImage_name, ")") : void 0
        }
      }, _react.default.createElement("span", {
        className: "status-icon",
        "data-status": this.passed ? 'passed' : 'failed'
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": this.passed ? 'check' : 'clear'
      })), this.passed ? _react.default.createElement("h3", null, "Congratulations! You have passed") : _react.default.createElement("h3", null, "Sorry... You did not pass"), _react.default.createElement("h1", null, this.course.title), _react.default.createElement("div", {
        className: "type"
      }, _react.default.createElement("p", null, this.course.type))), this.rewards.length ? _react.default.createElement("div", {
        className: "rewards"
      }, _react.default.createElement("h3", null, "Rewards earned"), _react.default.createElement("div", {
        className: "reward-item-body"
      }, this.rewards.map(function (item) {
        var Reward = require("rewards/view/".concat(item.reward.child_type)).default;

        return _react.default.createElement("div", {
          className: "reward-item",
          key: item.rule.id
        }, _react.default.createElement(Reward, {
          item: item.reward,
          rule: item.rule,
          data: item
        }));
      }))) : null, _react.default.createElement("footer", null, !!this.rewards.length && _react.default.createElement("p", null, _react.default.createElement("span", {
        className: "bold"
      }, "TIP:"), " Access your rewards anytime from your profile menu."), this.nextItem ? _react.default.createElement("button", {
        className: "btn btn-primary",
        type: "button",
        onClick: this.goToItems
      }, "Continue") : _react.default.createElement("button", {
        className: "btn btn-primary",
        "data-dismiss": "modal",
        type: "button"
      }, "Close")));
    }
  }, {
    key: "goToItems",
    value: function goToItems() {
      this.setState({
        showingNext: true
      });
    }
  }]);
  return CompletionBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "course", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "rewards", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "passed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "nextItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "goToItems", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "goToItems"), _class.prototype)), _class);
exports.CompletionBody = CompletionBody;

var CompletionModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(CompletionModal, _Modal);

  function CompletionModal(passed, course, rewards, nextItem) {
    var _this2;

    babelHelpers.classCallCheck(this, CompletionModal);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CompletionModal).call(this, 'completion-modal'));
    _this2.innerWrapper = false;
    _this2.hasModalTitleElement = false;
    _this2.passed = passed;
    _this2.course = course;
    _this2.rewards = rewards;
    _this2.nextItem = nextItem;
    return _this2;
  }

  babelHelpers.createClass(CompletionModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this3 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(CompletionModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        _reactDom.default.render(_react.default.createElement(CompletionBody, {
          passed: _this3.passed,
          course: _this3.course,
          rewards: _this3.rewards,
          nextItem: _this3.nextItem
        }), element.querySelector('.form-body'));

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class='form-body'></div>\n\t\t";
    }
  }]);
  return CompletionModal;
}(_base.default);

exports.CompletionModal = CompletionModal;

function show(passed, course, rewards, nextItem) {
  new CompletionModal(passed, course, rewards, nextItem).show();
}